<template>
  <component :is="icon" :key="name" :class="className" />
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue';

const props = defineProps({
  /**
   * Required name of the svg file
   */
  name: {
    type: String,
    required: true,
  },
  /**
   * Optional title
   */
  title: {
    type: String,
    default: '',
  },
});

const icon = computed(() =>
  defineAsyncComponent(() => import(`../assets/icons/${props.name}.svg`))
);

const className = computed(() => `icon icon--${props.name}`);
</script>